<template>
  <div class="dg-actions">
    <dangerousGoodProofAction
      :item="item"
      :config="config"
      @reloadData="$emit('reloadData')"
    />
    <v-tooltip bottom v-if="canCreateHere">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="copyItem(item)"
          data-cy="copy"
          >content_copy</v-icon
        >
      </template>
      <span>{{ $t("dangerousGoods.dangerousGoodsList.copy") }}</span>
    </v-tooltip>
    <!-- <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="moveItem(item)"
          data-cy="copy"
          >content_paste_go</v-icon
        >
      </template>
      <span>{{ $t("dangerousGoods.dangerousGoodsList.move") }}</span>
    </v-tooltip> -->
    <v-tooltip bottom v-if="!isReadOnlyUser">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="openMoveDialog(item)"
          data-cy="move"
        >
          content_paste_go
        </v-icon>
      </template>
      <span>{{ $t("dangerousGoods.dangerousGoodsList.move") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="!isReadOnlyUser">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="editItem(item)"
          data-cy="edit"
        >
          edit</v-icon
        >
      </template>
      <span>{{ $t("dangerousGoods.dangerousGoodsList.edit") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="canDeleteHere">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          v-on="on"
          @click.stop="openDeleteDialog(item)"
          data-cy="delete"
        >
          delete</v-icon
        >
      </template>
      <span>{{ $t("dangerousGoods.dangerousGoodsList.delete") }}</span>
    </v-tooltip>
    <deleteDialog
      @triggerDelete="deleteItem"
      :item="item"
      :deleteDialog="deleteDialog"
    />
    <moveDialog
      :item="item"
      :moveDialog="moveDialog"
      :loading="moving"
      :array="storageLocations"
      @cancel="moveDialog.open = false"
      @reload="reloadDataFunc"
      @confirm="handleMoveConfirm"
    />
  </div>
</template>

<script>
import dangerousGoodProofAction from "./dangerousGoodProofAction.vue";
import deleteDialog from "../../../_utils/dataTableHelpers/actions/deleteDialog.vue";
import moveDialog from "../../../_utils/dataTableHelpers/actions/moveDialog.vue";
import { getUniqueId } from "../../../../components/api/api";

export default {
  props: ["item", "config"],
  components: {
    deleteDialog,
    moveDialog,
    dangerousGoodProofAction,
  },
  data: () => ({
    deleteDialog: {
      open: false,
      title: "dangerousGoods.dangerousGoodsList.delete",
      description: "",
    },
    moveDialog: {
      open: false,
      title: "dangerousGoods.dangerousGoodsList.move",
      description: "",
      targetId: null,
    },
    moving: false,
    tableData: {
      tableComponentSlots: [
        {
          id: getUniqueId(),
          slotName: "item.storageLocationAction",
          componentName: "storageLocationAction",
        },
      ],
      itemKey: "id",
      uriPartPrepend: "dangerousGoodStorageLocation",
      uriPartAppend: "",
      populate: [],
      sort: "-createdAt",
      editFormPushName: "dangerousGoodsStorageLocationForm",
      detailViewPushName: "dangerousGoodsList",
    },
    storageLocations: [],
  }),
  methods: {
    editItem(item) {
      this.$router.push({
        name: "dangerousGoodsListForm",
        params: {
          storageLocationId: this.$route.params.storageLocationId,
          storageLocationName: this.$route.params.storageLocationName,
          id: item.id,
          mode: "edit",
        },
      });
    },
    copyItem(item) {
      this.$router.push({
        name: "dangerousGoodsListForm",
        params: {
          storageLocationId: this.$route.params.storageLocationId,
          storageLocationName: this.$route.params.storageLocationName,
          id: item.id,
          mode: "copy",
        },
      });
    },
    openDeleteDialog(item) {
      this.deleteDialog.open = true;
      this.deleteDialog.description = this.$t(
        "dangerousGoods.dangerousGoodsList.deleteLong",
        {
          name: item.name,
        }
      );
    },
    deleteItem(item) {
      this.$store.dispatch("deleteDangerousGood", item).then(() => {
        this.reloadDataFunc();
        this.deleteDialog.open = false;
      });
    },
    reloadDataFunc() {
      this.$emit("reloadData");
    },
    async openMoveDialog(item) {
      this.moveDialog.open = true;
      this.moveDialog.targetId = item.id;
      this.moveDialog.description = this.$t(
        "dangerousGoods.dangerousGoodsList.movingGood",
        { name: item.name }
      );

      const result = await this.$store.dispatch(
        "getAllDangerousGoodsStorageLocations"
      );

      const allLocations = Array.isArray(result)
        ? result
        : result?.items || result?.data || [];

      const currentId = this.$route.params.storageLocationId;

      this.storageLocations = allLocations.filter(
        (loc) => String(loc.id) !== String(currentId)
      );
    },
    async handleMoveConfirm(targetId) {
      try {
        this.moving = true;
        await this.$store.dispatch("moveDangerousGood", {
          id: this.item.id,
          dangerousGoodStorageLocation: targetId,
        });
        this.moveDialog.open = false;
        this.reloadDataFunc();
      } finally {
        this.moving = false;
      }
    },
  },
};
</script>

<style scoped>
.dg-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
}
</style>
